module.exports = __webpack_public_path__ + "media/que_deviennent_mes_vetements/02-consume-less-3637015f.png";